import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  AddonBlueprint,
  type TechDocsAddonOptions,
} from '@backstage/plugin-techdocs-react/alpha';
import { Mermaid } from 'backstage-plugin-techdocs-addon-mermaid';
import { createElement } from 'react';

const MermaidWithZoom = () => {
  return createElement(Mermaid, {
    enableZoom: true,
    zoomOptions: {
      scaleExtent: [0.1, 10],
      translateExtent: [
        [-1000, -1000],
        [1000, 1000],
      ],
    },
  });
};

const mermaidAddonParams: TechDocsAddonOptions = {
  name: 'Mermaid',
  location: 'Content',
  component: MermaidWithZoom,
};

const techDocsMermaidWithZoomAddon = AddonBlueprint.make({
  name: 'mermaid',
  params: mermaidAddonParams,
});

export const techDocsMermaidWithZoomModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [techDocsMermaidWithZoomAddon],
});
